
import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,

    /* Hooks */
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { noop } from '@salesforce/retail-react-app/app/utils/utils'

/* Components */
import CountrySelector from '../../country-selector'

const FooterCountrySelector = ({
    onShowCountrySelectorOnFooter = noop
}) => {
    const countrySelectorRef = useRef(null)
    const isMobile = useBreakpointValue({ base: true, md: false })
    const isDesktop = useBreakpointValue({ base: false, md: true })

    return (
        <Box>
            {isMobile &&
                <Flex
                    align="center"
                    ml="auto"
                    columnGap={1}
                    onClick={() => {
                        if (isMobile && countrySelectorRef.current?.onToggle) {
                            countrySelectorRef.current.onToggle()
                        }
                    }}
                    onKeyDown={(e) => {
                        e.preventDefault()
                        if (isMobile && e.key === 'Enter' && countrySelectorRef.current?.onToggle) {
                            countrySelectorRef.current.onToggle()
                        }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label="Country selector"
                >
                    <CountrySelector
                        variant='footer'
                        triggerRef={countrySelectorRef}
                        onShowCountrySelectorOnFooter={onShowCountrySelectorOnFooter}
                    />
                </Flex>
            }

            {isDesktop &&
                <Flex
                    align="center"
                    justify="end"
                    columnGap={1}
                >
                    <CountrySelector
                        variant='footer'
                        triggerRef={countrySelectorRef}
                        onShowCountrySelectorOnFooter={onShowCountrySelectorOnFooter}
                    />
                </Flex>
            }
        </Box>
    )
}

FooterCountrySelector.propTypes = {
    onShowCountrySelectorOnFooter: PropTypes.func
}

export default FooterCountrySelector
